<div
  fxLayout="row"
  fxLayout.xs="column"
  style="height: 778px !important; min-height: 500px"
>
  <as-split direction="horizontal">
    <as-split-area size="30">
      <div fxLayout="column" fxLayout.xs="column">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h6>{{ siteId }}</h6>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-sm-12">
              <button
                id="meterView-collapse-tree"
                mat-raised-button
                (click)="tree.treeControl.collapseAll()"
              >
                CollapseAll
              </button>
              &nbsp;
              <button
                id="meterView-expand-tree"
                mat-raised-button
                (click)="tree.treeControl.expandAll()"
              >
                ExpandAll
              </button>
            </div>
          </div>
          <div class="row">
            <mat-tree
              #tree
              [dataSource]="dataSource"
              [(treeControl)]="treeControl"
            >
              <mat-tree-node
                [id]="node.title"
                class="site-mat-tree-node"
                *matTreeNodeDef="let node"
                matTreeNodeToggle
                matTreeNodePadding
                (click)="activeNode = node"
              >
                <button
                  id="meterView-node"
                  type="button"
                  (click)="$event.preventDefault()"
                  mat-icon-button
                  disabled
                ></button>

                <mat-label
                  class="site-tree-node"
                  [ngClass]="{ 'site-node-actived': activeNode === node }"
                  (click)="featureLeafItemSelectionToggle(node)"
                >
                  {{ node.title }}
                </mat-label>
              </mat-tree-node>

              <mat-tree-node
                [id]="node.title"
                class="site-mat-tree-node"
                *matTreeNodeDef="let node; when: hasChild"
                matTreeNodePadding
              >
                <button
                  id="meterView-tree-node"
                  type="button"
                  (click)="$event.preventDefault()"
                  mat-icon-button
                  matTreeNodeToggle
                  [attr.aria-label]="'toggle ' + node.filename"
                >
                  <mat-icon
                    *ngIf="treeControl.isExpanded(node)"
                    fontIcon="Bosch-Ic-arrow-expand-down"
                  ></mat-icon>
                  <mat-icon
                    *ngIf="!treeControl.isExpanded(node)"
                    fontIcon="Bosch-Ic-arrow-expand-right"
                  ></mat-icon>
                </button>

                <mat-label
                  class="site-tree-node"
                  (click)="featureItemSelectionToggle(node)"
                  >{{ node.title }}</mat-label
                >
              </mat-tree-node>
            </mat-tree>
          </div>
        </mat-expansion-panel>
      </div>
    </as-split-area>
    <as-split-area size="70">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h6>Meter View</h6>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div
          fxLayout="row"
          fxLayout.xs="column"
          style="align-items: center !important"
          class="site-layout"
        >
          <div
            fxFlex="25%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
          >
            <div [chart]="realtimePowerChart"></div>
          </div>
          <div
            fxFlex="25%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
          >
            <div [chart]="voltageChart"></div>
          </div>
          <div
            fxFlex="25%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
          >
            <div [chart]="currentChart"></div>
          </div>
          <div
            fxFlex="25%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
          >
            <div [chart]="powerFactorChart"></div>
          </div>
        </div>
        <div></div>
        <mat-action-row class="expansion-footer">
          <mat-label>
            Data for load
            <span class="current-node-title">{{ currentNode.nodeTitle }}</span>
            at <span class="current-node-title">{{ txtime }}</span>
          </mat-label>
        </mat-action-row>
      </mat-expansion-panel>
    </as-split-area>
  </as-split>
</div>
